import React, {useEffect, useRef} from "react";
import feather from "feather-icons";

type FeatherIconName = keyof typeof feather.icons;

interface FeatherIconProps {
    name: FeatherIconName;
    className?: string;
    strokeWidth?: number;
}

const FeatherIcon: React.FC<FeatherIconProps> = ({ name, className, strokeWidth = 2 }) => {
    const ref = useRef<HTMLSpanElement | null>(null);

    useEffect(() => {
        if (!ref.current) return;

        const icon = feather.icons[name];
        ref.current.innerHTML = icon
            ? icon.toSvg({ class: className, "stroke-width": String(strokeWidth) })
            : "";
    }, [name, className, strokeWidth]);

    return <span aria-hidden ref={ref} />;
};

export default FeatherIcon;